import { gql } from '@apollo/client'

export const WINNIN_AI_REPORT_WALLET_QUERY = gql`
  query GenerateWinninAIReportModal_WinninAIReportWallet {
    myWallet {
      amount
    }
  }
`

export const GET_TERRITORY_ANALYSIS_ELIGIBILITY = gql`
  query Modal_GetTerritoryAnalysisEligibility($data: GetAutomaticJobTerritoryAnalysisEligibilityInput!) {
    getAutomaticJobTerritoryAnalysisEligibility(data: $data)
  }
`

export const GET_WEEKLY_AGENDA_ELIGIBILITY = gql`
  query Modal_GetWeeklyAgendaEligibility($data: GetAutomaticJobWeeklyScheduleEligibilityInput!) {
    getAutomaticJobWeeklyScheduleEligibility(data: $data)
  }
`

export const GET_TREND_ANALYSIS_ELIGIBILITY = gql`
  query Modal_GetTrendAnalysisEligibility($data: GetAutomaticJobTrendAnalysisEligibilityInput!) {
    getAutomaticJobTrendAnalysisEligibility(data: $data)
  }
`

export const GET_CREATORS_SEARCH_ELIGIBILITY = gql`
  query Modal_GetCreatorsSearchEligibility($data: GetAutomaticJobSearchCreatorsEligibilityInput!) {
    getAutomaticJobSearchCreatorsEligibility(data: $data)
  }
`

export const GET_GENERATED_REPORTS_COUNT = gql`
  query Modal_WinninAIReportCountTotalReports {
    getAutomaticJobCount
  }
`
